"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardType = void 0;
var CardType;
(function (CardType) {
    CardType["EVENT"] = "event";
    CardType["ACTIVE"] = "active";
    CardType["AUTOMATED"] = "automated";
    CardType["PRELUDE"] = "prelude";
    CardType["CORPORATION"] = "corporation";
    CardType["STANDARD_PROJECT"] = "standard_project";
    CardType["STANDARD_ACTION"] = "standard_action";
    CardType["PROXY"] = "proxy";
})(CardType = exports.CardType || (exports.CardType = {}));
//# sourceMappingURL=CardType.js.map